<template>
  <div class="d-flex flex-column justify-center align-center pt-5">
    <v-dialog
      v-model="invalid_mobile_dialog" max-width="500"
    >
      <v-card >
        <div class="d-flex flex-row justify-center align-center pa-5">
          <h1>
            ไม่สามารถใส่หมายเลขนี้ได้
          </h1>
        </div>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="invalid_mobile_dialog = false"
          >
            ปิด
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    ส่งรายการสินค้า
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
      style="width:70%"
    >
      <v-text-field
        v-model="name"
        :rules="[v => !!v || 'กรุณากรอกชื่อลูกค้า']"
        label="ชื่อ - นามสกุล (ลูกค้า) *"
        required
      ></v-text-field>

      <v-text-field
        v-model="telephone"
        :rules="telephoneRules"
        label="เบอร์โทรศัพท์ (ไม่ต้องใส่ขีด) *"
        required
      ></v-text-field>

      <v-text-field
        v-model="houseNo"
        :rules="[v => !!v || 'กรุณาเลือกใส่บ้านเลขที่']"
        label="บ้านเลขที่ *"
        required
      ></v-text-field>

      <v-select
        v-model="province"
        :items="provinceList"
        :rules="[v => !!v || 'กรุณาเลือกจังหวัด']"
        label="จังหวัด"
        required
        @change="generateDistrictList(province)"
      ></v-select>

      <v-select
        v-model="district"
        :items="districtList"
        :rules="[v => !!v || 'กรุณาเลือกอำเภอ']"
        label="อำเภอ"
        required
        @change="generateSubdistrictList(district)"
      ></v-select>

      <v-select
        v-model="subdistrict"
        :items="subdistrictList"
        :rules="[v => !!v || 'กรุณาเลือกจังหวัดตำบล']"
        label="ตำบล"
        required
      ></v-select>

      <v-text-field
        v-model="postcode"
        :rules="postcodeRules"
        label="รหัสไปรษณีย์ *"
        required
      ></v-text-field>

      <v-select
        v-model="productType"
        :items="productTypeList"
        :rules="[v => !!v || 'กรุณาเลือกประเภทสินค้า']"
        label="ประเภทสินค้า"
        required
      ></v-select>

      <v-text-field
        v-model="productTransaction"
        :rules="[v => !!v || 'กรุณากรอกรายการสินค้าที่สั่ง']"
        label="รายการสินค้าที่สั่ง *"
        required
      ></v-text-field>

      <v-text-field
        v-model="productPrice"
        :rules="priceRules"
        label="ราคาสินค้า *"
        required
      ></v-text-field>

      <v-text-field
        v-model="priceOther"
        :rules="priceOtherRules"
        label="ค่าใช้จ่ายอื่นๆ"
      ></v-text-field>

      <v-select
        v-model="paymentMethod"
        :items="paymentMethodList"
        :rules="[v => !!v || 'กรุณาเลือกวิธีการชำระสินค้า']"
        label="วิธีการชำระ *"
        required
      ></v-select>

      <v-text-field
        v-model="paymentMethodOther"
        v-if="paymentMethod == 'อื่นๆ'"
        label="วิธีการชำระอื่นๆ"
      ></v-text-field>

      <v-file-input
        v-model="moneySlip"
        show-size
        label="แนบสลิปการโอนเงิน"
      ></v-file-input>

      <v-text-field
        v-model="note"
        label="หมายเหตุ"
      ></v-text-field>

      <v-btn
        :disabled="!valid"
        color="success"
        class="mr-4"
        @click="validate"
      >
        ส่งข้อมูล
      </v-btn>

      <v-btn
        color="yellow"
        class="mr-4"
        @click="reset"
      >
        ล้างข้อมูล
      </v-btn>

      <v-btn
        color="error"
        class="mr-4"
        @click="change_status_to_z"
      >
        ลบข้อมูล
      </v-btn>
    </v-form>
    <v-snackbar
      v-model="snackbar"
    >
      {{ snackbar_text }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="pink"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          ปิด
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
  export default {
    data: () => ({
      snackbar: false,
      snackbar_text: '',
      valid: true,
      transactionId: 0,
      name: '',
      telephone: '',
      houseNo: '',
      province: '',
      provinceList: [],
      district: '',
      districtList: [],
      invalid_mobile_dialog: false,
      subdistrict: '',
      subdistrictList: [],
      postcode: '',
      thailandAddress: [],
      mobile_avilable_result: [],
      telephoneRules: [
        v => !!v || 'กรุณาใส่เบอร์โทรศัพท์',
        v => Number.isInteger(Number(v)) || "กรุณาใส่เป็นเลขเท่านั้น",
      ],
      postcodeRules: [
        v => !!v || 'กรุณาใส่รหัสไปรษณีย์',
        v => Number.isInteger(Number(v)) || "กรุณาใส่เป็นเลขเท่านั้น",
      ],
      priceRules: [
        v => !!v || 'กรุณากรอกราคาสินค้า',
        v => Number.isInteger(Number(v)) || "กรุณาใส่เป็นเลขเท่านั้น",
      ],
      priceOtherRules: [
        v => Number.isInteger(Number(v)) || "กรุณาใส่เป็นเลขเท่านั้น",
      ],
      productType: '',
      productTypeList: ['Beta-X', 'Beta - Cal', 'Beta - LIV', 'Beta - Flow', 'Beta - SIS', 'Beta - Hearb', 'Beta Oil', 'Beta M', 'Beta E', 'Beta Green', 'Beta Hair', 'Abbie', 'Lab Farm', 'ลูกอม', 'Beta Life'],
      productTransaction: '',
      paymentMethod: '',
      paymentMethodList: ['โอนเงิน', 'เก็บเงินปลายทาง', 'อื่นๆ'],
      paymentMethodOther: '',
      productPrice: 0,
      priceOther: 0,
      note: '',
      moneySlip: '',
      mobile_used_list: []
    }),
    mounted () {
      this.$store.dispatch('adminUpdateTransaction')

      this.thailandAddress = require('../assets/thailand_address.json')
      this.getMobileUsed()
      this.getMobileAvailable()
      this.$refs.form.reset()
      
      // this.telephone = this.$router.currentRoute.query.mobile
      for (let i = 0; i < this.thailandAddress.length; i++) {
        if (!this.provinceList.includes(this.thailandAddress[i].chw_tname)) {
          this.provinceList.push(this.thailandAddress[i].chw_tname)
        }
      }
      this.provinceList.sort()

      this.transactionId = this.$store.state.adminUpdateTransaction.id
      this.name = this.$store.state.adminUpdateTransaction.name
      this.telephone = this.$store.state.adminUpdateTransaction.mobile
      this.houseNo = this.$store.state.adminUpdateTransaction.address1
      this.province = this.$store.state.adminUpdateTransaction.province
      this.generateDistrictList(this.province)
      this.district = this.$store.state.adminUpdateTransaction.district
      this.generateSubdistrictList(this.district)
      this.subdistrict = this.$store.state.adminUpdateTransaction.subdistrict
      this.postcode = this.$store.state.adminUpdateTransaction.postcode
      this.productType = this.$store.state.adminUpdateTransaction.product_type
      this.productTransaction = this.$store.state.adminUpdateTransaction.product
      this.productPrice = this.$store.state.adminUpdateTransaction.price
      if (this.$store.state.adminUpdateTransaction.price_other == null) {
        this.priceOther = 0
      }
      else {
        this.priceOther = this.$store.state.adminUpdateTransaction.price_other
      }
      this.note = this.$store.state.adminUpdateTransaction.note
      if (this.$store.state.adminUpdateTransaction.payment_method == null) {
        this.paymentMethod = ''
      }
      else {
        this.paymentMethod = this.$store.state.adminUpdateTransaction.payment_method
        if (!this.paymentMethodList.includes(this.paymentMethod)) {
          this.paymentMethod = 'อื่นๆ'
          this.paymentMethodOther = this.$store.state.adminUpdateTransaction.payment_method
        }
      }
    },
    methods: {
      checkTelephone (v) {
        return this.mobile_used_list.includes(v)
      },
      generateDistrictList(province) {
        this.districtList = []
        this.subdistrictList = []
        this.district = ''
        this.subdistrict = ''
        for (let i = 0; i < this.thailandAddress.length; i++) {
          if (this.thailandAddress[i].chw_tname === province) {
            if (!this.districtList.includes(this.thailandAddress[i].amp_name)) {
              this.districtList.push(this.thailandAddress[i].amp_name)
            }
          }
        }
        this.districtList.sort()
      },
      generateSubdistrictList(district) {
        this.subdistrictList = []
        this.subdistrict = ''
        for (let i = 0; i < this.thailandAddress.length; i++) {
          if (this.thailandAddress[i].chw_tname === this.province && this.thailandAddress[i].amp_name === district) {
            if (!this.subdistrictList.includes(this.thailandAddress[i].name_t)) {
              this.subdistrictList.push(this.thailandAddress[i].name_t)
            }
          }
        }
        this.subdistrictList.sort()
      },
      objectToFormData (obj = {}) {
          let formData = new FormData()
              for (let key in obj) {
                  if (typeof obj[key] === 'object' && !(obj[key] instanceof File)) {
                  for (let item in obj[key]) {
                      if (typeof obj[key][item] === 'object' && !(obj[key][item] instanceof File)) {
                          for (let index in obj[key][item]) {
                              formData.append(`${key}[${item}][${index}]`, obj[key][item][index])
                          }
                      } else {
                          formData.append(`${key}[${item}]`, obj[key][item])
                      }
                  }
              } else {
                  formData.append(key, obj[key])
              }
          }
          return formData
      },
      async change_status_to_z () {
        const user_cookie = this.$cookie.get('user');
        const user = JSON.parse(user_cookie)
        console.log(user)
        const mobile_used_result = await this.$store.dispatch('changeStatusToZ', {
          uuid: user.uuid,
          id: this.transactionId,
        })
        this.$router.push('/admin')
        console.log(mobile_used_result)
      },
      async updateTransaction () {
        const user_cookie = this.$cookie.get('user');
        const user = JSON.parse(user_cookie)

        console.log(user)

        let param_obj = {
          uuid: user.uuid,
          transactionId: this.transactionId,
          name: this.name,
          telephone: this.telephone.trim(),
          houseno: this.houseNo,
          province: this.province,
          district: this.district,
          subdistrict: this.subdistrict,
          postcode: this.postcode,
          product_type: this.productType,
          product: this.productTransaction,
          price: this.productPrice,
          price_other: this.priceOther,
          payment_method: null,
          note: null,
          slip: null,
        }
        if (this.paymentMethod == 'อื่นๆ') {
          param_obj.payment_method = this.paymentMethodOther
        }
        else {
          param_obj.payment_method = this.paymentMethod
        }
        if (this.note != '') {
          param_obj.note = this.note
        }
        if (this.moneySlip != '') {
          param_obj.slip = this.moneySlip
        }

        let params = this.objectToFormData(param_obj)

        const create_transaction_result = await this.$store.dispatch('updateTransaction', params)

        console.log(create_transaction_result)
        if (create_transaction_result == 'updateTransaction') {
          this.snackbar_text = 'ส่งข้อมูลเรียบร้อย'
          this.snackbar = true
          this.$refs.form.reset()
          // this.getMobileUsed()
          this.$router.push('/admin')
        } else {
          this.snackbar_text = 'เกิดปัญหาในการส่งข้อมูล'
          this.snackbar = true
        }
      },
      async getMobileUsed () {
        const user_cookie = this.$cookie.get('user');
        const user = JSON.parse(user_cookie)

        console.log(user)
        const mobile_used_result = await this.$store.dispatch('getMobileUsed', {
          uuid: user.uuid,
        })

        this.mobile_used_list = []
        for (let i = 0; i < mobile_used_result.length; i++) {
          this.mobile_used_list.push(mobile_used_result[i].mobile)
        }

        console.log(this.mobile_used_list)
      },
      async getMobileAvailable () {
        const user_cookie = this.$cookie.get('user');
        const user = JSON.parse(user_cookie)

        console.log(user)
        const mobile_avilable_result = await this.$store.dispatch('getMobileAvailable', {
          uuid: user.uuid,
        })

        this.mobile_avilable = []
        for (let i = 0; i < mobile_avilable_result.length; i++) {
          this.mobile_avilable.push(mobile_avilable_result[i].mobile)
        }

        console.log(this.mobile_avilable)
      },
      validate () {
        let result = this.$refs.form.validate()
        
        let check_mobile_result = this.checkTelephone(this.telephone)

        if (check_mobile_result) {
          result = false
          this.snackbar_text = 'ห้ามใส่เบอร์ซ้ำกับที่ส่งในวันนี้'
          this.snackbar = true
        }

        const user_cookie = this.$cookie.get('user');
        let user = JSON.parse(user_cookie)
        let mobile_check = false
        console.log(user.roles)
        for (let i = 0; i < user.roles.length; i++) {
          if (user.roles[i] == 'user' || user.roles[i] == 'sale') {
            if (this.mobile_avilable.includes(this.telephone)) {
              mobile_check = true
            }
            else {
              mobile_check = false
              this.invalid_mobile_dialog = true
            }
          }
          else {
            mobile_check = true
          }
        }
        
        if (result && mobile_check) {
          this.updateTransaction()
        }
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
    }
  }
</script>